import { render, staticRenderFns } from "./textDialog.vue?vue&type=template&id=1df10b48&lang=pug"
import script from "./textDialog.vue?vue&type=script&lang=js"
export * from "./textDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports